import { render } from "./KnowledgeAgentPage.vue?vue&type=template&id=ae91fcbe&scoped=true"
import script from "./KnowledgeAgentPage.vue?vue&type=script&lang=js"
export * from "./KnowledgeAgentPage.vue?vue&type=script&lang=js"

import "./KnowledgeAgentPage.vue?vue&type=style&index=0&id=ae91fcbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae91fcbe"]])

export default __exports__